import React, { useEffect, useState } from "react";
import { publicAPI } from "../../api";
import {
  PageBanner,
  SectionHeader,
  Loader,
} from "../../components/common/CommonComponents";
import { getImageUrl, sanitizeHTML, stripHtml } from "../../utils/helpers";

const About = () => {
  const [sections, setSections] = useState([]);
  const [leadership, setLeadership] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const [secR, leadR] = await Promise.all([
          publicAPI.getPageSections("about"),
          publicAPI.getLeadership(),
        ]);
        setSections(secR.data.data || []);
        setLeadership(leadR.data.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const getSection = (key) => sections.find((s) => s.section_key === key);
  const overview = getSection("overview");
  const vision = getSection("vision_mission");

  if (loading) return <Loader />;

  return (
    <div>
      <PageBanner
        title="About Us"
        subtitle="Discover our legacy of academic excellence"
        breadcrumbs={[{ label: "About Us" }]}
      />

      {/* Overview */}
      <section className="section">
        <div className="container">
          <SectionHeader
            label="Who We Are"
            title={
              stripHtml(overview?.title) ||
              "PeopleTree Education Society – Belagavi"
            }
          />
          <div
            style={{
              display: "grid",
              gridTemplateColumns: overview?.image_url ? "1.2fr 1fr" : "1fr",
              gap: "3rem",
              alignItems: "center",
            }}
          >
            <div
              className="rich-content"
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(
                  overview?.content ||
                    "<p>PeopleTree Group of Institutions is a premier educational institution dedicated to shaping future leaders. With a strong emphasis on holistic development, we provide students with the knowledge, skills, and values they need to succeed in a rapidly changing world.</p>",
                ),
              }}
            />
            {overview?.image_url && (
              <div>
                <img
                  src={getImageUrl(overview.image_url)}
                  alt={overview.title || "About PeopleTree"}
                  style={{
                    width: "100%",
                    borderRadius: "var(--radius-lg)",
                    boxShadow: "var(--shadow-lg)",
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Vision & Mission */}
      <section className="section section--alt">
        <div className="container">
          <div
            className="grid grid--2"
            style={{ gap: "3rem", alignItems: "start" }}
          >
            <div className="card" style={{ padding: "var(--sp-2xl)" }}>
              <h3
                style={{
                  color: "var(--clr-secondary)",
                  marginBottom: "var(--sp-md)",
                }}
              >
                Our Vision
              </h3>
              <div
                style={{ color: "var(--clr-text-light)", lineHeight: 1.8 }}
                dangerouslySetInnerHTML={{
                  __html:
                    vision?.title ||
                    "To be a globally recognized institution nurturing innovation, leadership, and excellence in every student.",
                }}
              />
            </div>
            <div className="card" style={{ padding: "var(--sp-2xl)" }}>
              <h3
                style={{
                  color: "var(--clr-secondary)",
                  marginBottom: "var(--sp-md)",
                }}
              >
                Our Mission
              </h3>
              <div
                style={{ color: "var(--clr-text-light)", lineHeight: 1.8 }}
                dangerouslySetInnerHTML={{
                  __html:
                    vision?.subtitle ||
                    "To provide quality education through innovative teaching, industry collaboration, and a supportive environment that fosters holistic development.",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Leadership */}
      {leadership.length > 0 && (
        <section className="section">
          <div className="container">
            <SectionHeader label="Leadership" title="Our Guiding Force" />
            <div className="grid grid--3">
              {leadership
                .filter((l) => l.is_active)
                .map((l) => (
                  <div
                    key={l.id}
                    className="card"
                    style={{ textAlign: "center" }}
                  >
                    <div
                      style={{
                        width: 120,
                        height: 120,
                        borderRadius: "50%",
                        background: "var(--clr-primary)",
                        margin: "2rem auto 1rem",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: "2rem",
                        fontFamily: "var(--font-display)",
                        overflow: "hidden",
                      }}
                    >
                      {l.photo_url ? (
                        <img
                          src={getImageUrl(l.photo_url)}
                          alt={l.name}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                          }}
                        />
                      ) : (
                        l.name?.charAt(0)
                      )}
                    </div>
                    <div className="card__body">
                      <h4
                        className="card__title"
                        style={{ fontSize: "var(--fs-md)" }}
                      >
                        {l.name}
                      </h4>
                      <p
                        style={{
                          color: "var(--clr-secondary)",
                          fontSize: "var(--fs-sm)",
                          marginBottom: "var(--sp-md)",
                        }}
                      >
                        {l.designation}
                      </p>
                      {l.message && (
                        <p
                          className="card__text"
                          style={{ fontSize: "var(--fs-sm)" }}
                        >
                          {l.message.substring(0, 150)}...
                        </p>
                      )}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </section>
      )}
    </div>
  );
};

const stripSection = (html, keyword) => {
  const text = html.replace(/<[^>]*>/g, "");
  return text.substring(0, 300);
};

export default About;
